import React, { Component } from 'react';
import { Meteor } from 'meteor/meteor';
import PropTypes from 'prop-types';
import Iframe from 'react-iframe';

import methodPromise from '../../../modules/method-promise-wrapper';
import handleErrorInClient from '../../../modules/handle-error-in-client';

import BlankState from '../../components/BlankState';

import Styles from './styles';

const { isTierra2 } = Meteor.settings.public;

class Atlas extends Component {
  state = {
    tierra2API: ''
  };

  componentDidMount() {
    this.getTierra2API();
  }

  getTierra2API = async () => {
    const { authenticated } = this.props;
    if (isTierra2) {
      try {
        const tierra2API = await methodPromise('app.getTierra2API', authenticated);
        this.setState({ tierra2API });
      } catch (error) {
        handleErrorInClient(error);
      }
    }
  };

  render() {
    const { tierra2API } = this.state;

    if (isTierra2) {
      return (
        <Styles.AtlasContainer>
          <Iframe url={tierra2API} width="100%" height="100%" />
        </Styles.AtlasContainer>
      );
    }

    return (
      <BlankState
        icon={{ style: 'solid', symbol: 'cogs' }}
        title="This feature is not ready yet. Coming Soon"
        subtitle=""
      />
    );
  }
}

Atlas.propTypes = {
  authenticated: PropTypes.bool.isRequired
};

export default Atlas;
